// Secciones del menú de navegación, compartidas por la barra de escritorio y
// la móvil. `to` es la ruta de la sección; `incluye` lista las rutas que no
// están en el menú pero dejan marcada esa sección (pantallas de detalle).

export const MENU_ADMIN = [
  { title: "Revisiones", icon: "mdi-message-draw", to: "/admin_revisiones", incluye: ["/practica"] },
  { title: "Estadísticas", icon: "mdi-chart-bar", to: "/estadisticas" },
  { title: "Solicitudes", icon: "mdi-frequently-asked-questions", to: "/admin_solicitudes" },
  { title: "Alumnos", icon: "mdi-account", to: "/alumnos", incluye: ["/alumno"] },
  { title: "Logs", icon: "mdi-message-alert", to: "/logs" },
  { title: "Empresas", icon: "mdi-domain", to: "/admin_empresas" },
  { title: "Comentarios al DI", icon: "mdi-message-alert", to: "/comentarios_di" },
  { title: "Exportadores", icon: "mdi-database-export", to: "/exportadores" },
  { title: "Configuración", icon: "mdi-cog", to: "/configuracion" },
];

export const MENU_ALUMNO = [
  { title: "Prácticas", icon: "mdi-book", to: "/user_dashboard", incluye: ["/new_practica", "/finalizar_practica"] },
  { title: "Mi perfil", icon: "mdi-file-account", to: "/perfil" },
  { title: "Empresas", icon: "mdi-domain", to: "/empresas" },
  { title: "Estadísticas", icon: "mdi-chart-bar", to: "/estadisticas" },
  { title: "Informaciones", icon: "mdi-information-outline", to: "/informaciones", incluye: ["/info_proceso", "/preguntas_frecuentes"] },
];

// Se compara por segmento completo para que "/alumno" no calce con "/alumnos".
function dentroDe(path, base) {
  return path === base || path.startsWith(base + "/");
}

// Devuelve el `to` de la sección a la que pertenece `path`, o undefined si no
// pertenece a ninguna.
export function seccionActiva(menu, path) {
  const seccion = menu.find((item) =>
    [item.to, ...(item.incluye || [])].some((base) => dentroDe(path, base))
  );
  return seccion && seccion.to;
}
